export default "__VITE_ASSET__V_0Fpsxl__"